import { Component, OnInit } from '@angular/core';

import { CBMError, Maintenance } from 'app/models';
import { MaintenanceService } from 'app/services';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  public maintenance: Maintenance;
  public showAlertSaved: boolean;
  public errorMessages: CBMError[] = [];

  constructor(private readonly maintenanceService: MaintenanceService) {}

  ngOnInit() {
    this.showAlertSaved = false;
    this.maintenance = new Maintenance(false, '', false, '');

    this.maintenanceService.getMaintenance().subscribe(
      response => {
        this.maintenance = response;
      },
      (errors: CBMError[]) => console.log(errors)
    );
  }

  public onSubmit(): void {
    this.showAlertSaved = false;

    this.maintenanceService.setMaintenance(this.maintenance).subscribe(
      response => {
        this.showAlertSaved = true;
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
        console.log(errors);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/maintenance/maintenance.component.ts